import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_ErrorText, EAA_Upload, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import Extend_Reason from './Extend_Reason';
import Extend_Additional from './Extend_Additional';

const modeInfo = {
  add: {
    title: '展延申請新增',
  },
  edit: {
    title: '展延申請編輯',
  },
  view: {
    title: '展延申請檢視',
  },
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getExtendIdDetail, mode = '', setPageText, getBaseData } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getExtendIdDetail(id);
    getBaseData();
  }

  componentDidUpdate (preProps) {
    const { extendIdDetail: preExtendIdDetail = {} } = preProps;
    const { extendIdDetail = {}, mode } = this.props;
    if (Object.keys(preExtendIdDetail).length === 0 && Object.keys(extendIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: extendIdDetail, old_data: extendIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('ExtendIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      official_doc_date: data.official_doc_date || '',
      official_doc_num: data.official_doc_num || '',
      official_doc_upload_files: data.official_doc_upload_files || [],
      extend_target: data.extend_target || '',
      contract_select_rule: data.contract_select_rule || '',
      extend_apply_freq: data.extend_apply_freq || '',
      review_results: data.review_results || '',
      review_official_doc_date: data.review_official_doc_date || '',
      review_official_doc_num: data.review_official_doc_num || '',
      review_official_doc_upload_files: data.review_official_doc_upload_files || [],
      sub1: data.sub1 || [],
      sub2: data.sub2 || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const { postAddNewExtend } = this.props;
    const body = { ...this.getSendBody(), ...status };
    postAddNewExtend(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putExtendIdDetail } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putExtendIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.official_doc_date) === '', // 公文日期
      returnInputValue(data.official_doc_num) === '', // 公文文號
      (data.official_doc_upload_files || []).length === 0, // 公文檔案
      returnInputValue(data.extend_target) === '', // 展延標的
      returnInputValue(data.contract_select_rule) === '', // 申請變更依據
      returnInputValue(data.extend_apply_freq) === '', // 展延次數
      returnInputValue(data.review_official_doc_date) === '', // 審查公文日期
      returnInputValue(data.review_official_doc_num) === '', // 審查公文文號
      (data.review_official_doc_upload_files || []).length === 0, // 審查檔案
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

0
  returnTargetText=() => {
    const { ExtendTarget = [], ExtendTargetText = {} } = this.props;
    const { data = {} } = this.state;
    const index = ExtendTarget.findIndex(o => o.value === data.extend_target);
    if (index > -1) {
      return ((ExtendTargetText.items || [])[index] || {}).text || '';
    }

    return '';
  }

  render () {
    const { mode = '', ExtendTarget = [] } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    const titleWidth = 170;
    const errorLeft = 20 + titleWidth;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <SearchBar text='展延申請函' defaultOpen forceOpen={errorAry[0] || errorAry[1] || errorAry[2]}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文日期' bol={true} haveChange={checkChange('official_doc_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.official_doc_date)} onChange={data => this.changeData({ label: 'official_doc_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文文號' bol={true} haveChange={checkChange('official_doc_num')} />
                <EAA_Input displayBorder unit='字號' disabled={disabled} value={returnInputValue(data.official_doc_num)} onChange={data => { this.changeData({ label: 'official_doc_num', data }); }} />
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳檔案' bol={true} haveChange={checkFilesChange('official_doc_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.official_doc_upload_files || []} onChange={data => this.changeData({ label: 'official_doc_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='展延標的' forceOpen={errorAry[3]}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='展延標的' bol={true} haveChange={checkChange('extend_target')} />
                <EAA_Select displayBorder disabled={disabled} list={ExtendTarget} value={returnInputValue(data.extend_target)} onChange={data => { this.changeData({ label: 'extend_target', data }); }} />
              </EAA_ItemContainer>
              {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>
          <div style={{ whiteSpace: 'pre-line', textAlign: 'start' }}>{this.returnTargetText()}</div>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='申請變更依據' forceOpen={errorAry[4]}>
          <EAA_TitleText width={titleWidth} text='請勾選下列契約條文' subtitle={errorAry[4] ? '請勾選' : ''} subtitleColor='red' bol={true} haveChange={checkChange('contract_select_rule')} />
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox disabled={disabled} value={data.contract_select_rule === '1'} onClick={() => this.changeData({ label: 'contract_select_rule', data: '1' })} />
                <div style={{ textAlign: 'start', marginLeft: 8 }}>
                  <div>離岸風電規劃場址遴選契約書(中華民國 109 年完工併聯) :</div>
                  <div>第 11 條第 1 項(因不可抗力或不可歸責於乙方 等正當事由 ，致無法完成本契約第五條至第七條所定義務者，乙方檢附文件後於 期限屆至前九十日內，向甲方申請並經同意後予以展延，每次展延期限不得逾六個月。)</div>
                </div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox disabled={disabled} value={data.contract_select_rule === '2'} onClick={() => this.changeData({ label: 'contract_select_rule', data: '2' })} />
                <div style={{ textAlign: 'start', marginLeft: 8 }}>
                  <div>離岸風電規劃場址遴選契約書(中華民國 110-114 年完工併聯) :</div>
                  <div>第 12 條第 1 項(因不可抗力或不可歸責於乙方 等正當事由 ，致無法完成本契約第五條至第八條所定義務者，乙方檢附文件後於 期限屆至前九十日內，向甲方申請並經同意後予以展延，每次展延期限不得逾六個月。)</div>
                </div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox disabled={disabled} value={data.contract_select_rule === '3'} onClick={() => this.changeData({ label: 'contract_select_rule', data: '3' })} />
                <div style={{ textAlign: 'start', marginLeft: 8 }}>
                  <div>離岸風電規劃場址競價契約書:</div>
                  <div>第 12 條第 1 項(因不可抗力或不可歸責於乙方 等正當事由 ，致無法完成本契約第六條至第八條所定義務者，乙方檢附文件後於 期限屆至前九十日內，向甲方申請並經同意後予以展延，每次展延期限不得逾六個月。)</div>
                </div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='展延次數' forceOpen={errorAry[5]}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='本次為第' subtitle='' bol={true} haveChange={checkChange('extend_apply_freq')} />
                <EAA_Input displayBorder disabled={disabled} type='number' hint='數字' unit='次提出申請' value={data.extend_apply_freq} onChange={data => this.changeData({ label: 'extend_apply_freq', data })} />
              </EAA_ItemContainer>
              {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>
        </SearchBar>

        <Extend_Reason disabled={disabled} data={data.sub1 || []} onChange={data => this.changeData({ label: 'sub1', data })} />

        <Extend_Additional disabled={disabled} data={data.sub2 || []} onChange={data => this.changeData({ label: 'sub2', data })} list={(data.sub1 || []).map(o => ({ value: o.extend_desc, name: o.extend_desc })).filter(o => (o.value && o.value.length > 0))} />

        <SearchBar style={{ marginTop: 8 }} text='審查結果' forceOpen={errorAry[6] || errorAry[7] || errorAry[8]}>
          <EAA_TitleText width={250} text='本次展延申請案已取得經濟部' haveChange={checkChange('review_results')} />
          <EAA_Row style={{ marginTop: 8 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <CircleCheckBox disabled={disabled} value={data.review_results === '1'} onClick={() => this.changeData({ label: 'review_results', data: '1' })} />
                <div style={{ marginRight: 8 }}>同意變更</div>
                <CircleCheckBox disabled={disabled} value={data.review_results === '2'} onClick={() => this.changeData({ label: 'review_results', data: '2' })} />
                <div>不同意變更</div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <div style={{ marginTop: 24, fontWeight: 700, fontSize: 16, textAlign: 'start' }}>經濟部同意/不同意函文</div>
          <EAA_Row style={{ marginTop: 8 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文日期' bol={true} haveChange={checkChange('review_official_doc_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.review_official_doc_date)} onChange={data => this.changeData({ label: 'review_official_doc_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公文文號' bol={true} haveChange={checkChange('review_official_doc_num')} />
                <EAA_Input displayBorder disabled={disabled} unit='字號' value={data.review_official_doc_num} onChange={data => this.changeData({ label: 'review_official_doc_num', data })} />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳檔案' bol={true} haveChange={checkFilesChange('review_official_doc_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.review_official_doc_upload_files || []} onChange={data => this.changeData({ label: 'review_official_doc_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewExtend' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutExtendIdDetail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  extendIdDetail: state.data.ExtendIdDetail,
  ExtendTarget: state.data.ExtendTarget,
  ExtendTargetText: state.data.ExtendTargetText,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getBaseData: () => {
    Actions_Wind.getExtendTargetText(dispatch);
    Actions_Wind.getExtendSupReason(dispatch);
    Actions_Wind.getExtendReason(dispatch);
    Actions_Wind.getExtendRule(dispatch);
  },
  getExtendIdDetail: id => Actions_Wind.getExtendIdDetail(dispatch, { id }),
  postAddNewExtend: body => Actions_Wind.postAddNewExtend(dispatch, { body }),
  putExtendIdDetail: (id, body) => Actions_Wind.putExtendIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
